import { render } from "./AboutTech.vue?vue&type=template&id=4822aa90"
import script from "./AboutTech.vue?vue&type=script&lang=js"
export * from "./AboutTech.vue?vue&type=script&lang=js"

import "./AboutTech.vue?vue&type=style&index=0&id=4822aa90&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__